module.exports = __webpack_public_path__ + "static/media/uwmath.eec77e1c.png";